import { render, staticRenderFns } from "./tro-choi.vue?vue&type=template&id=c7051ac6&"
import script from "./tro-choi.vue?vue&type=script&lang=js&"
export * from "./tro-choi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports